import e from "../../utils/classNames.js";
import t from "../../utils/mergeRefs.js";
import { useAnchorName as n, usePopover as r } from "../../hooks/useAnchoredPopover.js";
import i from "../../utils/getReactElementRef.js";
import a from "../dialog/Dialog.js";
import o from "./ActionBarItemListSeparator.js";
import s from "./ActionBarItemListItem.js";
import c from "./ActionBarItemList.js";
import l from "./ActionBarOverlay.js";
import u from "./ActionBarItemPopoverContent.js";
import d from "./ActionBarItemIcon.js";
import f, { memo as p, useCallback as m, useEffect as h, useLayoutEffect as g, useRef as _, useState as v } from "react";
import { negate as y } from "es-toolkit/function";
import { delay as b, head as x } from "es-toolkit/compat";
import { jsx as S, jsxs as C } from "react/jsx-runtime";
//#region src/components/actionBarItem/ActionBarItem.tsx
var w = "mousedown", T = "show", E = "position-offscreen", D = 250, O = 200, k = 580, A = () => (Math.random() + 1).toString(36).toUpperCase().substring(2), j = (e, t) => e.classList.contains(t), M = y(j), N = (e, t) => !t.contains(e), P = () => {
	let [e, t] = v(!1);
	return h(() => {
		let e = x(document.getElementsByClassName("ApplicationHeader")), n = e ? e.offsetWidth < k : !1;
		t(n);
	}, []), e;
}, F = (e) => e.type && e.type.displayName === u.displayName, I = (e) => e.type && e.type.displayName === d.displayName, L = p((o) => {
	let { id: s = A(), className: c, mobileDialogBodyClassName: u = "", children: d, popoverWidth: p = D, hidePopoverOnClick: h = !0, ...y } = o, [x, k] = v(!1), [L, R] = v(null), [z, B] = v(null), V = n("action-bar-item");
	r(z, x);
	let H = _(null);
	g(() => {
		let e = (e) => {
			if (!H?.current || !x) return;
			let t = document.getElementById(s);
			if (!t || e.target.offsetParent === H.current) return;
			let n = N(e.target, t);
			if (j(t, T) && M(t, E) && n) {
				k(!1);
				return;
			}
			h && b(() => k(!1), O);
		};
		return document.addEventListener(w, e), () => {
			document.removeEventListener(w, e);
		};
	}, [
		H,
		s,
		x
	]);
	let U = e("ActionBarItem", c), W = P(), G = m(() => k(!x), [k, x]), K = f.Children.toArray(d), q = K.find(F), J = K.find(I);
	if (!q) return /* @__PURE__ */ S("div", {
		className: U,
		children: d
	});
	let { useOffscreen: Y = !1, title: X } = q.props, Z = K.filter((e) => !F(e)).filter((e) => !I(e));
	if (W) return /* @__PURE__ */ C("div", {
		...y,
		className: U,
		ref: H,
		children: [
			J && f.cloneElement(J, { onClick: G }),
			/* @__PURE__ */ S("div", {
				onClick: () => k(!1),
				children: /* @__PURE__ */ S(a, {
					show: x,
					onClose: () => k(!1),
					body: q,
					bodyClassName: u,
					title: X
				})
			}),
			Z
		]
	});
	let Q = J, $ = Q.props.onClick, ee = f.cloneElement(Q, {
		ref: t([i(Q), R]),
		onClick: (e) => {
			G(), $?.(e);
		},
		style: {
			...Q.props.style || {},
			anchorName: V
		}
	}), te = {
		positionAnchor: V,
		"--overlay-anchor-width": L ? `${L.offsetWidth}px` : void 0,
		"--overlay-anchor-height": L ? `${L.offsetHeight}px` : void 0
	}, ne = (x || Y) && /* @__PURE__ */ S(l, {
		ref: B,
		id: s,
		title: X,
		width: p,
		preRender: Y,
		show: x,
		style: te,
		children: q
	}, "child");
	return /* @__PURE__ */ C("div", {
		...y,
		className: U,
		ref: H,
		children: [
			ne,
			ee,
			Z
		]
	});
});
L.Icon = d, L.Popover = u, L.List = c, L.ListItem = s, L.ListSeparator = o;
//#endregion
export { L as default };

//# sourceMappingURL=ActionBarItem.js.map